import store from '../store/store';
import { assertNever } from 'owa-assert';
import SpamScenarioId from '../store/schema/SpamScenarioId';

/**
 * Returns a subset of mailbox junk email configuration object which is observable depending on
 * which scenarioId is provided. Ex: Safe senders, Safe domains etc.
 */
export default function getMailboxJunkEmailByScenarioId(scenarioId: SpamScenarioId): string[] {
    switch (scenarioId) {
        case SpamScenarioId.BlockedSendersAndDomains:
            return store.mailboxJunkEmailConfiguration.BlockedSendersAndDomains;
        case SpamScenarioId.SafeSendersAndDomains:
            return store.mailboxJunkEmailConfiguration.TrustedSendersAndDomains;
        case SpamScenarioId.SafeMailingLists:
            return store.mailboxJunkEmailConfiguration.TrustedRecipientsAndDomains;
        default:
            return assertNever(scenarioId);
    }
}
